// extracted by css-extract-rspack-plugin
export default {"widgetGallerySwitcher":"widget-gallery-switcher--lrLOKvQoupQjt7eS","widgetGallerySwitcherButton":"widget-gallery-switcher-button--IDhS_76d_fwmj3_e"};